import React, { useState } from 'react';
import CommonConfigDialog from './CommonConfigDialog';
import { DialogInput, RequiredDialogInput, RequiredDialogSelect, DialogCheckbox } from '../../DialogInputs';
import { handleInputChange } from '../../Utilities/DialogUtils';
import { useHttpUtils } from '../../Utilities/useHttpUtils';

function RecipeTypeEditDialog({ dialogData, setDialogData, showDialog, closeDialog, businessUnits }) {

    const { fetchDataAuthenticated } = useHttpUtils();
    const [fieldErrors, setFieldErrors] = useState({});

    const saveRecipeType = (recipeType) => {

        let promise = new Promise((resolve, reject) => {
            let url = `api/v1/recipetype`;
            if (recipeType.recipeTypeId != null) {
                url += `/${recipeType.recipeTypeId}`
            }
            
            fetchDataAuthenticated(url, "POST", JSON.stringify(recipeType))
                .then(response => response.json())
                .then(data => {
                    if (data.errors !== null && data.errors !== undefined) {
                        reject(data);
                    }
                    resolve(data);
                })
                .catch(error => {
                    alert("There was a problem! " + error);
                });

        });

        return promise;
    };

    const onChange = (e) => {
        handleInputChange(e, dialogData, setDialogData, fieldErrors, setFieldErrors);
    }
    
    return (
        <CommonConfigDialog title={"Equipment Type - " + dialogData.name} dialogData={dialogData} showDialog={showDialog} closeDialog={closeDialog} save={saveRecipeType} fieldErrors={fieldErrors} setFieldErrors={setFieldErrors}>
            <RequiredDialogInput controlId="formRecipeTypeName" title="Name" name="name" value={dialogData.name} error={fieldErrors.name} onChange={onChange} />
            <DialogInput controlId="formRecipeTypeDescription" title="Description" name="description" value={dialogData.description} error={fieldErrors.description} onChange={onChange} />
            <RequiredDialogSelect controlId="formRecipeTypeBusinessUnit" title="Business Unit" name="businessUnitId" value={dialogData.businessUnitId} error={fieldErrors.businessUnitId} onChange={onChange}>
                <option value="" key={0} >Please Select...</option>
                {businessUnits.map((bu) => <option value={bu.businessUnitId} key={bu.businessUnitId}>{bu.name}</option>)}
            </RequiredDialogSelect>
            <DialogCheckbox disabled={dialogData.recipeTypeId === null} controlId="formRecipeTypeIsDeleted" title="Deleted?" name="isDeleted" checked={dialogData.isDeleted} error={fieldErrors.isDeleted} onChange={onChange} />
        </CommonConfigDialog>
    );
}

export default RecipeTypeEditDialog;